import { getTopicDetailQueryOptions } from '@/utils/fetchers/topic'
import { assertTopicRoute } from '@/utils/navigate'
import queryClient from '@/utils/queryClient'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/topic/$id/')({
	component: () => null,
	loader: async ({ params }) => {
		const topic = await queryClient.ensureQueryData(getTopicDetailQueryOptions(params.id))
		assertTopicRoute(topic)

		return {
			data: topic,
		}
	},
})
